import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * FAQSchema Component
 * Renders FAQ structured data (schema.org) for rich search results
 * Place on any page with frequently asked questions
 */
export default function FAQSchema({ faqItems = [] }) {
  if (!faqItems || faqItems.length === 0) return null;

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map((item) => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </Helmet>
  );
}